module.exports = __webpack_public_path__ + "img/ng_fluent_filteroff_20_regular.64587104.svg";